import React from "react";
import TextButtonView from "presentational/common/TextButtonView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  root: {
    marginTop:
      desktopCss.paddingBetweenTextButton -
      desktopCss.standardPaddingBetweenContent,
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end"
  }
};
const cssXS = {
  root: {
    marginTop:
      mobileCss.paddingBetweenTextButton -
      mobileCss.standardPaddingBetweenContent,
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap"
  }
};

MyOutfitTabBarView.propTypes = {
  value: PropTypes.oneOf(["mylist", "favorites"]).isRequired,
  onTabBtnClick: PropTypes.func.isRequired
};

function MyOutfitTabBarView(props) {
  const { value, onTabBtnClick } = props;

  const css = getDeviceType() === "mobile" ? cssXS : cssXL;

  return (
    <div style={css.root}>
      <TextButtonView
        design={value === "mylist" ? "select" : "unselect"}
        onClick={onTabBtnClick("mylist")}
      >
        <TXT name="btnTab_allOutfits" />
      </TextButtonView>
      <TextButtonView
        design={value === "favorites" ? "select" : "unselect"}
        disableRightMargin
        onClick={onTabBtnClick("favorites")}
      >
        <TXT name="btnTab_picks" />
      </TextButtonView>
    </div>
  );
}

export default MyOutfitTabBarView;
